<template>
    <div class="container-wrapper">
        <div class="container">
            <input
                    ref="checkbox"
                    
                    class="k-checkbox custom-kendo-checkbox-for"
                    type="checkbox"
                    v-bind:checked="checked"
            />

            <label 
                    class="k-checkbox-label dmv-text dmv-text-primary"
                    @click.self.prevent="clicked"
            >
                {{label}}
            </label>
        </div>
    </div>
</template>

<script>
    import {guid} from "../../../../../Util/guid";

    //IE is trash, thus we need to explicitly listen to our label for click events
    //instead of just input on our checkbox
    
    export default {
        name: "scenario-list-item-checkbox",
        created(){
            const vm = this;
            vm.controlId = `CHK_${guid()}`;
            vm.checked = vm.value;
        },
        methods: {
            clicked(){
                const vm = this;
                const el = vm.$refs.checkbox;

                //Toggle checked
                vm.checked = !vm.checked;
                el.checked = vm.checked;
                vm.$emit('input', vm.checked);
            }
        },
        data: () => ({
            controlId: '',
            checked: false
        }),
        props: {
            label: {
                type: String,
                required: true
            },
            value: {
                type: Boolean,
                required: true
            }
        }
    }
</script>

<style scoped src="../../../Style/info-checkbox.scss" lang="scss">
</style>
